import { SecretsManagerClient, GetSecretValueCommand, GetSecretValueResponse } from '@aws-sdk/client-secrets-manager';
import { CognitoService } from './CognitoService';

/**
 * Retrieves a secret from AWS Secrets Manager
 * @param secretArn - The ARN of the secret to retrieve
 * @param region - AWS region
 * @returns Promise<GetSecretValueResponse | undefined>
 */
export const getSecretValue = async (secretArn: string, region: string): Promise<GetSecretValueResponse | undefined> => {
  try {
    if (!secretArn) {
      throw new Error('Secret ARN is required');
    }

    const secretsManagerClient = new SecretsManagerClient({
      region,
      credentials: CognitoService.credentialProvider
    });
    const command = new GetSecretValueCommand({ SecretId: secretArn });

    return await secretsManagerClient.send(command);
  } catch (error) {
    console.error('Error retrieving secret:', error);
    throw error;
  }
};
